import thunk from 'redux-thunk'
import logger from 'redux-logger'
import { configureStore } from '@reduxjs/toolkit'
import tenantReducer from '../features/ami-meter-data-collection/redux/tenantSlice'
import languageReducer from './language'
import kpiDailyReducer from '../features/ami-meter-data-collection/redux/kpiDailySlice'
import deviceInfoReducer from '../features/upload-file/redux/deviceInfoSlice'
import assetByIdReducer from '../features/device-details/redux/assetByIdSlice'
import assetIdReducer from '../features/device-details/redux/assetIdSlice'
import templateDetailsReducer from '../features/configuration-upload-status/redux/selectedTemplateDetailsSlice'
import assetPHistoryReducer from '../features/device-provisioning/redux/assetProvisioingHistoryInfoSlice'
import deviceListSlice from '../features/ami-meter-data-collection/redux/deviceListSlice'
import deviceDetailReducer from '../features/device-provisioning/redux/ShowAssetDetailsSlice'
import channelDataDeviceDetailsReducer from '../features/device-details/redux/channelDataSlice'
import deviceDetailsListReducer from '../features/device-details/redux/deviceListSlice'
import deviceDataReducer from '../features/device-provisioning/redux/ProvisioningHistorySummaryDetailsInfoSlice'
import registerReadingsReducer from '../features/device-details/redux/registerReadingsSlice'
import exportAssetProvisioningDetailsReducer from '../features/device-provisioning/redux/exportAssetProvisioningDetailsSlice'
import exportProvisioningHistoryByIdReducer from '../features/device-provisioning/redux/exportProvisioningHistoryByIdSlice'
import exportProvisioningHistoryReducer from '../features/device-provisioning/redux/exportProvisioningHistorySlice'
import alarmByIdReducer from '../features/device-details/redux/alarmsByIdSlice'
import allAlarmsReducer from '../features/ami-meter-data-collection/redux/allAlarmsSlice'
import totalIssueCountReducer from '../features/ami-meter-data-collection/redux/activeIssuesCountSlice'
import addFirmwareInfoReducer from '../features/firmware/redux/addFirmwareInfoSlice'
import topIssuesReducer from '../features/ami-meter-data-collection/redux/topIssuesSlice'
import signalDataReducer from '../features/device-details/redux/cellularSignalSlice'
import provisioningHistoryDetailsFilterDeviceTypeReducer from '../features/device-provisioning/redux/provisioningHistoryDetailsFilterDeviceTypeSlice'
import provisioningHistoryDetailsFilterStateReducer from '../features/device-provisioning/redux/provisioningHistoryDetailsFilterStateSlice'
import provisioningHistoryFilterStatusReducer from '../features/device-provisioning/redux/provisioningHistoryFilterStatusSlice'
import provisioningHistoryFilterUploadedUsersReducer from '../features/device-provisioning/redux/provisioningHistoryFilterUploadedUsersSlice'
import parameterListReducer from '../features/asset-configuration/redux/parameterListSlice'
import channelDataReducer from '../features/device-details/redux/channelDropdownSlice'
import firmawareListReducer from '../features/firmware/redux/firmwareListInfoSlice'
import firmwareTypeReducer from '../features/firmware/redux/getFirmwareTypeDataInfoSlice'
import getFirmwareFilterAssetTypeReducer from '../features/firmware/redux/getFirmwareFilterAssetTypeSlice'
import getFirmwareFilterFirmwareTypeReducer from '../features/firmware/redux/getFirmwareFilterFirmwareTypeSlice'
import getFirmwareFilterVersionReducer from '../features/firmware/redux/getFirmwareFilterVersionSlice'
import exportFirmwareListReducer from '../features/firmware/redux/exportFirmwareListSlice'
import deleteFirmwareReducer from '../features/firmware/redux/deleteFirmwareSlice'
import configurationListReducer from '../features/asset-configuration/redux/configurationListSlice'
import configurationDetailsForStatusReducer from '../features/configuration-upload-status/redux/configurationDetailsSlice'
import associateAssetsReducer from '../features/asset-configuration/redux/associateAssetsSlice'
import assetTypesReducer from '../features/asset-configuration/redux/assetTypeSlice'
import createConfigurationReducer from '../features/asset-configuration/redux/createConfigurationSlice'
import assetListByAssetTypeReducer from '../features/asset-configuration/redux/unAssignedAssetsListSlice'
import disassociateAssetsReducer from '../features/asset-configuration/redux/disassociateAssetsSlice'
import configurationsForStatusReducer from '../features/configuration-upload-status/redux/configurationListForStatusSlice'
import configurationDetailsReducer from '../features/asset-configuration/redux/configDetailsSlice'
import templateIdReducer from '../features/asset-configuration/redux/templateIdSlice'
import configIdReducer from '../features/data-publisher/redux/configIdSlice'
import assignedAssetListReducer from '../features/asset-configuration/redux/assignedAssetListSlice'
import thirtyDayReducer from '../features/ami-meter-data-collection/redux/thirtyDaySlice'
import grandParentBreadcrumbReducer from '../features/dashboard/redux/grandParentBreadcrumbSlice'
import allConfigDataReducer from '../features/data-publisher/redux/allConfigSlice'
import allStatusFilesReducer from '../features/data-publisher/redux/fileStatusSlice'
import createReducer from '../features/data-publisher/redux/addNewConfigSlice'
import operationPermissionsReducer from '../features/dashboard/redux/operationPermissionSlice'
import kpiTypeReducer from '../features/ami-meter-data-collection/redux/changeKpiType'
import hamburgerStateReducer from '../features/dashboard/redux/hamburgerSlice'
import ipConfigReducer from '../features/device-details/redux/ipConfigSlice'
import groupListReducer from '../features/device-provisioning/redux/groupListSlice'
import updateGroupReducer from '../features/device-provisioning/redux/updateGroupSlice'
import createGroupProvicioningReducer from '../features/device-provisioning/redux/createGroupSlice'
import AssetGroupsListReducer from '../features/asset-group/redux/AssetGroupsListSlice'
import singleConfigReducer from '../features/data-publisher/redux/singleConfigSlice'
import updateConfigReducer from '../features/data-publisher/redux/updateConfigSlice'
import deleteConfigReducer from '../features/data-publisher/redux/deleteConfigSlice'
import AssetStatesTypeDataReducer from '../features/ami-meter-data-collection/redux/assetStatesSlice'
import updateAssetStateReducer from '../features/ami-meter-data-collection/redux/updateAssetStateSlice'
import createGroupReducer from '../features/asset-group/redux/createGroupSlice'
import assetForCreateGroupReducer from '../features/asset-group/redux/assetForCreateGroupSlice'
import editAssetSummaryReducer from '../features/device-details/redux/editAssetSummaryInfoSlice'
import AssetGroupDetailsReducer from '../features/asset-group/redux/AssetGroupDetailsSlice'
import AssetAssignedListReducer from '../features/asset-group/redux/AssetAssignedListSlice'
import UnassignedAssetListReducer from '../features/asset-group/redux/UnassignedAssetListSlice'
import updateGroupDetailsReducer from '../features/asset-group/redux/updateGroupSlice'
import getAllTagsByIdSliceReducer from '../features/device-details/redux/getAllTagsByIdSlice'
import getAllGroupFilterParameterSliceReducer from '../features/asset-group/redux/getAllGroupFilterParameterSlice'
import CreateGroupFirmwareReducer from '../features/firmware/redux/createGroupSlice'
import FirmwareAssignGroupReducer from '../features/firmware/redux/firmwareAssignGroupSlice'
import DeleteGroupReducer from '../features/asset-group/redux/DeleteGroupSlice'
import ConfigurationAssignGroupReducer from '../features/asset-configuration/redux/configAssignGroupSlice'
import DeviceHistoryReducer from '../features/device-details/redux/deviceLifeCycleHistorySlice'
import getAllSchdulerListSliceReducer from '../features/data-publisher/redux/getAllSchdulerListSlice'
import createReportTemplateReducer from '../features/data-publisher/redux/createReportTemplateSlice'
import templateDetailsListReducer from '../features/data-publisher/redux/templateDetailsListSlice'
import reportContentColumnReducer from '../features/data-publisher/redux/reportContentColumnSlice'
import deleteReportTemplateSlice from '../features/data-publisher/redux/deleteReportTemplateSlice'
import editReportTemplateSlice from '../features/data-publisher/redux/editReportTemplateSlice'
import FirmwareUnassignGroupReducer from '../features/firmware/redux/firmwareUnassignGroupSlice'
import totalConnectedSlice from '../features/ami-meter-data-collection/redux/KpiSlices/totalConnectedSlice'
import totalRegisteredSlice from '../features/ami-meter-data-collection/redux/KpiSlices/totalRegisteredSlice'
import totalShippedSlice from '../features/ami-meter-data-collection/redux/KpiSlices/totalShippedSlice'
import totalStaleSlice from '../features/ami-meter-data-collection/redux/KpiSlices/totalStaleSlice'
import SchedulerDropDownReducer from '../features/data-publisher/redux/getAllCreateSchdulerDropdownSlice'
import createSchedulerTemplateReducer from '../features/data-publisher/redux/createReportSchedulerTemplateSlice'
import HistoryARTableReducer from '../features/ami-meter-data-collection/redux/HistoryARTableSlice'
import HistoryADSTableReducer from '../features/ami-meter-data-collection/redux/HistoryADSTableSlice'
import getSchedulerfilterDropdownReducer from '../features/data-publisher/redux/reportSchedulerFilterDropdownSlice'
import getKpiPreferenceReducer from '../features/ami-meter-data-collection/redux/getKpiPreferenceSlice'
import deleteSchedulerSlice from '../features/data-publisher/redux/deleteSchedulerSlice'
import exportSchedulerDataReducer from '../features/data-publisher/redux/exportSchedulerDataSlice'
import createSFTPConfigurationReducer from '../features/data-publisher/redux/CreateSftpConfigurationSlice'
import createConfigurationMetadataReducer from '../features/data-publisher/redux/configurationMetaDataSlice'
import configurationListDetailsReducer from '../features/data-publisher/redux/getConfigurationProtocolListSlice'
import updateConfigurationProtocolReducer from '../features/data-publisher/redux/updateConfigurationProtocolSlice'
import firmwareCampaignDetailsReducer from '../features/firmware/redux/firmwareUpgradeDetailsSlice'
import pauseSchedulerSlice from '../features/data-publisher/redux/pauseSchedulerSlice'
import resumeSchedulerSlice from '../features/data-publisher/redux/resumeSchedulerSlice'
import firmwareCreateCampaignReducer from '../features/firmware/redux/firmwareCreateCampaignSlice'
import firmwareCampaignListReducer from '../features/firmware/redux/firmwareCampaignListSlice'
import totalReadsDonutDataReducer from '../features/ami-meter-data-collection/redux/KpiSlices/totalReadsSlice'
import historyDonutReducer from '../features/ami-meter-data-collection/redux/historyDonutSlice'
import historyDonutTableReducer from '../features/ami-meter-data-collection/redux/HistoryDonutTableSlice'
import donutKpiBarGraphSlice from '../features/ami-meter-data-collection/redux/historyDonutKpiBarGraphSlice'
import ecModeDonutSlice from '../features/ami-meter-data-collection/redux/KpiSlices/ecModeSlice'
import signalBreakdownSlice from '../features/ami-meter-data-collection/redux/KpiSlices/signalBreakdownSlice'
import alarmBreakdownSlice from '../features/ami-meter-data-collection/redux/KpiSlices/alarmBreakdownSlice'
import firmwareBreakdownSlice from '../features/ami-meter-data-collection/redux/KpiSlices/firmwareBreakdownSlice'
import lastReadAlarmsReducer from '../features/ami-meter-data-collection/redux/KpiSlices/lastReadAlarmsSlice'
import HistoryASTableSlice from '../features/ami-meter-data-collection/redux/HistoryASTableSlice'
import batteryBreakdownSlice from '../features/ami-meter-data-collection/redux/KpiSlices/batteryBreakdownSlice'
import groupWithCountListReducer from '../features/firmware/redux/groupWithCountListSlice'
import firmwareCampaignDeleteReducer from '../features/firmware/redux/firmwareCampaignDeleteSlice'
import SchedulerHistoryListReducer from '../features/data-publisher/redux/getSchedulerHistoryDetailsSlice'
import exportFirmwareUpgradeStatusListReducer from '../features/firmware/redux/exportFirmwareUpgradeStatusSlice'
import exportFirmwareCampaignListReducer from '../features/firmware/redux/exportFirmwareCampaignDetailsSlice'
import getFirmwareCampaignFilterMetaDataReducer from '../features/firmware/redux/getFirmwareCampaignFilterMetaDataSlice'
import uploadAssetProfileInfoSlice from '../features/asset-configuration/redux/updateAssetProfileSlice'
import alarmHistorySlice from '../features/device-details/redux/alarmHistorySlice'
import seedReducer from '../features/device-provisioning/redux/setC12.22SeedSlice'
import lifecycleBreakdownSlice from '../features/ami-meter-data-collection/redux/KpiSlices/lifecycleBreakdownSlice'
import kpiListSlice from '../features/custom-performance-indicators/redux/kpiListSlice'
import deviceKpiListSlice from '../features/custom-performance-indicators/redux/deviceKpiListSlice'
import customKpiSlice from '../features/custom-performance-indicators/redux/customKpiSlice'
import assetListSlice from '../features/custom-performance-indicators/redux/assetListSlice'
import deviceParameterSlice from '../features/custom-performance-indicators/redux/deviceParameterSlice'
import createCustomKpiSlice from '../features/custom-performance-indicators/redux/createCustomKpiSlice'
import customKpiDetails from '../features/custom-performance-indicators/redux/customKpiDetailsSlice'
import deviceManagementDeviceListSlice from '../features/device-management/redux/deviceListSlice'
import deviceDeleteReducer from '../features/device-management/redux/deviceDeleteSlice'
import gatewayInfoSlice from '../features/device-management/redux/gatewayInfoSlice'
import assetCategoriesSlice from '../features/device-management/redux/assetCategoriesSlice'
import deviceTypeSlice from '../features/device-management/redux/deviceTypeSlice'
import deviceModelSlice from '../features/device-management/redux/deviceModelSlice'
import indicatorSlice from '../features/device-management/redux/indicatorSlice'
import deviceInfoSlice from '../features/device-management/redux/deviceInfoSlice'
import modbusParamsSlice from '../features/device-management/redux/modbusParamsSlice'
import updateDeviceReducer from '../features/device-management/redux/updateDeviceSlice'
import downloadImageReducer from '../features/device-management/redux/downloadImageSlice'
import imageUploadReducer from '../features/device-management/redux/imageUploadSlice'
import addDeviceIndicatorReducer from '../features/device-management/redux/addDeviceIndicatorSlice'
import addDeviceParameterReducer from '../features/device-management/redux/addDeviceParameterSlice'
import addDefaultParameterReducer from '../features/device-management/redux/addDefaultParameterSlice'
import gatewayManagementGatewayListSlice from '../features/gateway-management/redux/gatewayListSlice'
import assetManagementAssetListSlice from '../features/asset-managament/redux/assetListSlice'
import createAssetReducer from '../features/asset-managament/redux/createAssetSlice'
import imageUploadReducerAsset from '../features/asset-managament/redux/imageUploadSliceAsset'
import gatewayDeleteReducer from '../features/gateway-management/redux/gatewayDeleteSlice'
import assetInfoSlice from '../features/gateway-management/redux/assetInfoSlice'
import createDeviceReducer from '../features/device-management/redux/createDeviceSlice'
import siteInfoSlice from '../features/asset-managament/redux/siteInfoSlice'
import assetDeleteReducer from '../features/asset-managament/redux/assetDeleteSlice'
import modbusParamsSliceReducer from '../features/device-dashboard/redux/getModbusParamterslice'
import FlameSignaGraphDataSliceReducer from '../features/device-dashboard/redux/getFlameSignaGraphDataSlice'
import FlameSignaGraphDataSliceReducer_NEW from '../features/device-dashboard/redux/getFlameSignaGraphDataSliceNew'
import getFlameSignaGraphKPIDataSlice from '../features/device-dashboard/redux/getFlameSignaGraphKPIDataSlice'
import flowSignalParamDataSlice from '../features/device-dashboard/redux/getFlowSignaGraphParamDataSlice'
import flowSignalKpiDataSlice from '../features/device-dashboard/redux/getFlowSignaGraphKPIDataSlice'
import FlowSignaGraphDataSliceReducer from '../features/device-dashboard/redux/getFlowSignaGraphDataSlice'
import FlameSignaGraphDataAssetDashboardSliceReducer from '../features/asset-dashboard/redux/getFlameSignaGraphDataSlice'
import FlowSignaGraphDataAssetDashboardSliceReducer from '../features/asset-dashboard/redux/getFlowSignaGraphDataSlice'
import assetCategoriesSliceGateway from '../features/gateway-management/redux/assetCategoriesSliceGateway'
import gatewayTypeSlice from '../features/gateway-management/redux/gatewayTypeSlice'
import createGatewayReducer from '../features/gateway-management/redux/createGatewaySlice'
import imageUploadReducerGateway from '../features/gateway-management/redux/imageUploadSliceGateway'
import gatewayInfoSliceGateway from '../features/gateway-management/redux/gatewayInfoSliceGateway'
import updateGatewayReducer from '../features/gateway-management/redux/updateGatewaySlice'
import downloadImageReducerGateway from '../features/gateway-management/redux/downloadImageSliceGateway'
import siteList from '../features/custom-performance-indicators/redux/siteListSlice'
import DeviceListReducer from '../features/device-dashboard/redux/getDeviceListSlice'
import StandardandCustomListDataReducer from '../features/device-dashboard/redux/getStandardandCustomParamterSlice'
import updateAssetSlice from '../features/asset-managament/redux/updateAssetSlice'
import addDefaultIndicatorReducer from '../features/device-management/redux/addDefaultIndicatorSlice'
import siteManagementSiteListSlice from '../features/site-management/redux/siteListSlice'
import siteDeleteReducer from '../features/site-management/redux/siteDeleteSlice'
import createSiteReducer from '../features/site-management/redux/createSiteSlice'
import imageUploadReducerSite from '../features/site-management/redux/imageUploadSliceSite'
import editCustomKpiSlice from '../features/custom-performance-indicators/redux/editCustomKpiSlice'
import siteInfoReducer from '../features/site-management/redux/siteInfoSlice'
import downloadImageReducerSite from '../features/site-management/redux/downloadImageSliceSite'
import updateSiteReducer from '../features/site-management/redux/updateSiteSlice'
import kpiConfigurationSlice from '../features/custom-performance-indicators/redux/deviceKpiParameterSlice'
import DeviceStatusReducer from '../features/device-dashboard/redux/getDeviceStatusListSlice'
import AlertCountDetailsReducer from '../features/device-dashboard/redux/getAlertCountSlice'
import SaveDefaultViewDetailsReducer from '../features/device-dashboard/redux/saveDefaultViewSlice'
import AlertsNotificationReducer from '../features/device-dashboard/redux/getNotificationByFilterSlice'
import ClearNotificationReducer from '../features/device-dashboard/redux/clearNotificationServiceSlice'
import acknowledgeNotificationNotificationReducer from '../features/device-dashboard/redux/acknowledgeNotificationServiceSlice'
import DeviceOnlineStatusReducer from '../features/device-dashboard/redux/getDeviceStatusOnlineSlice'
import exportDeviceGrapData from '../features/device-dashboard/redux/exportGraphSlice'
import exportGraphKPIDataSlice from '../features/device-dashboard/redux/exportGraphKPIDataSlice'
import customDeviceListSlice from '../features/custom-device/redux/deviceListSlice'
import customDeviceDeleteReducer from '../features/custom-device/redux/deviceDeleteSlice'
import customDeviceInfoReducer from '../features/custom-device/redux/createDeviceInfoSlice'
import customDeviceDataExportReducer from '../features/custom-device/redux/exportCustomDeviceDataSlice'
import customDeviceDropDownMetaReducer from '../features/custom-device/redux/getDeviceDropDownMetaDataSlice'
import menuInfoReducer from '../features/dashboard/redux/menuInfoSlice'
import alarmMetaData from '../features/device-management/redux/alarmMetaDataSlice'
import frequencyMetaData from '../features/device-management/redux/frequencyMetaDataSlice'
import getDeviceByIdReducer from '../features/custom-device/redux/getDeviceDataByIdSlice'
import updateDeviceTemplateReducer from '../features/custom-device/redux/updateDeviceTemplateSlice'
import TimezoneDropDownReducer from '../features/gateway-management/redux/timezoneDataSlice'
import healthSummarySlice from '../features/device-dashboard/redux/getHealthSummarySlice'
import deviceStatusRegisterSummarySlice from '../features/device-dashboard/redux/getDeviceStatusSummaryRegisterSlice'
import deviceStatusKPISummarySlice from '../features/device-dashboard/redux/getDeviceStatusSummaryKPISlice'
import saveDefaultViewWidgetDetailsReducer from '../features/device-dashboard/redux/getSaveDefaultViewServiceSlice'
import SaveDefaultViewObjectReducer from '../features/device-dashboard/redux/saveDefaultViewObjectSlice'
import healthScoreReducer from '../features/asset-dashboard/redux/healthScoreSlice'
import assetAlarmReducer from '../features/asset-dashboard/redux/assetAlarmSlice'
import healthScoreAssetDashboardReducer from '../features/asset-dashboard/redux/getTotalHealthScoreSlice'
import assetHeaderRegisterSummaryReducer from '../features/asset-dashboard/redux/getAssetDashboardHeaderRegisterSummarySlice'
import assetHeaderKPISummaryReducer from '../features/asset-dashboard/redux/getAssetDashboardHeaderKPISummarySlice'
import addAssetKpiAlarmReducer from '../features/custom-performance-indicators/redux/addAssetKpiAlarmSlice'
import assetPerformanceDataReducer from '../features/asset-dashboard/redux/getAssetPerformanceDataSlice'
import assetPerformanceKPIDataReducer from '../features/asset-dashboard/redux/getAssetPerformanceKPIDataSlice'
import assetAlertCountDataReducer from '../features/asset-dashboard/redux/getAlertCountAssetDashbordSlice'
import alertTrendRegisterDataAssetDashboardReducer from '../features/asset-dashboard/redux/getAlertTrendRegisterDataSlice'
import alertTrendKPIDataAssetDashboardReducer from '../features/asset-dashboard/redux/getAlertTrendAssetKPIDataSlice'
import alertTrendRegisterDataDeviceDashboardReducer from '../features/device-dashboard/redux/getAlertTredRegisterDataSlice'
import alertTrendKPIDataDeviceDashboardReducer from '../features/device-dashboard/redux/getAlertTredKPIDataDeviceDashboardSlice'
import kpiAssetListReducer from '../features/custom-performance-indicators/redux/kpiAssetListSlice'
import parameterTreeReducer from '../features/asset-dashboard/redux/parameterTreeSlice'
import flameKPIAssetDataReducer from '../features/asset-dashboard/redux/getFlameKPIDataSlice'
import flameRegisterDateReducer from '../features/asset-dashboard/redux/getFlameRegisterDataSlice'
import flowKPIAssetDataReducer from '../features/asset-dashboard/redux/getFlowKPIDataSlice'
import flowRegisterDataReducer from '../features/asset-dashboard/redux/getFlowRegisterDataSlice'
import SaveBookmarkDetailsReducer from '../features/bookmarks-home/redux/toggleBookmarkSlice'
import GetBookmarkDetailsReducer from '../features/bookmarks-home/redux/getBookmarkSlice'
import SaveBookmarkObjectReducer from '../features/bookmarks-home/redux/saveBookmarkObjectSlice'
import emailGroupsListReducer from '../features/services/redux/emailGroupsListSlice'
import emailGroupDetailsReducer from '../features/services/redux/emailGroupDetailsSlice'
import getParameterConfigurationDataReducer from '../features/services/redux/parameterConfigurationsSlice'

const store = configureStore({
  reducer: {
    tenant: tenantReducer,
    language: languageReducer,
    kpiDailyData: kpiDailyReducer,
    deviceInfo: deviceInfoReducer,
    assetById: assetByIdReducer,
    assetId: assetIdReducer,
    deviceList: deviceListSlice,
    kpiList: kpiListSlice,
    emailGroupsList: emailGroupsListReducer,
    emailGroupDetails: emailGroupDetailsReducer,
    deviceKpiList: deviceKpiListSlice,
    deviceDetail: deviceDetailReducer,
    channelDataDeviceDetail: channelDataDeviceDetailsReducer,
    deviceDetailsList: deviceDetailsListReducer,
    assetProvisioningHistoryData: assetPHistoryReducer,
    deviceData: deviceDataReducer,
    registerReadingsData: registerReadingsReducer,
    exportAssetProvisioningDetails: exportAssetProvisioningDetailsReducer,
    exportProvisioningHistoryById: exportProvisioningHistoryByIdReducer,
    exportProvisioningHistory: exportProvisioningHistoryReducer,
    alarmsById: alarmByIdReducer,
    allActiveIssues: allAlarmsReducer,
    totalIssuesCount: totalIssueCountReducer,
    addFirmwareInfoSlice: addFirmwareInfoReducer,
    topIssues: topIssuesReducer,
    signalData: signalDataReducer,
    provisioningHistoryDetailsFilterDeviceType: provisioningHistoryDetailsFilterDeviceTypeReducer,
    provisioningHistoryDetailsStateFilter: provisioningHistoryDetailsFilterStateReducer,
    provisioningHistoryFilterStatus: provisioningHistoryFilterStatusReducer,
    provisioningHistoryFilterUploadedUsers: provisioningHistoryFilterUploadedUsersReducer,
    parameterList: parameterListReducer,
    AssetStatesTypeData: AssetStatesTypeDataReducer,
    updateAssetStateData: updateAssetStateReducer,
    channelDropdownData: channelDataReducer,
    firmwareListData: firmawareListReducer,
    firmwareTypeData: firmwareTypeReducer,
    firmwareFilterAssetType: getFirmwareFilterAssetTypeReducer,
    firmwareFilterFirmwareType: getFirmwareFilterFirmwareTypeReducer,
    firmwareFilterVersion: getFirmwareFilterVersionReducer,
    exportFirmwareList: exportFirmwareListReducer,
    deleteFirmware: deleteFirmwareReducer,
    configurationList: configurationListReducer,
    associateAssets: associateAssetsReducer,
    assetTypes: assetTypesReducer,
    createConfiguration: createConfigurationReducer,
    assetsByAssetType: assetListByAssetTypeReducer,
    disassociateAssets: disassociateAssetsReducer,
    configurationsForStatus: configurationsForStatusReducer,
    configurationDetails: configurationDetailsReducer,
    templateDetails: templateDetailsReducer,
    configurationDetailsForStatus: configurationDetailsForStatusReducer,
    templateIdForConfigurationDetails: templateIdReducer,
    configId: configIdReducer,
    assignedAssetList: assignedAssetListReducer,
    thirtyDay: thirtyDayReducer,
    grandParentBreadcrumb: grandParentBreadcrumbReducer,
    allConfigData: allConfigDataReducer,
    allStatusFiles: allStatusFilesReducer,
    createDatapubConfig: createReducer,
    operationPermissions: operationPermissionsReducer,
    kpiType: kpiTypeReducer,
    hamburgerState: hamburgerStateReducer,
    ipConfigState: ipConfigReducer,
    groupListData: groupListReducer,
    updateGroup: updateGroupReducer,
    createGroup: createGroupProvicioningReducer,
    assetGroupList: AssetGroupsListReducer,
    singleConfigData: singleConfigReducer,
    updateConfigData: updateConfigReducer,
    deleteConfigData: deleteConfigReducer,
    createGroupState: createGroupReducer,
    assetForCreateGroup: assetForCreateGroupReducer,
    EditAssetSummaryInfoSlice: editAssetSummaryReducer,
    assetGroupDetails: AssetGroupDetailsReducer,
    assetAssignedList: AssetAssignedListReducer,
    UnassignedAssetList: UnassignedAssetListReducer,
    updateGroupDetailsState: updateGroupDetailsReducer,
    getAllTags: getAllTagsByIdSliceReducer,
    getAllGroupFilterParamter: getAllGroupFilterParameterSliceReducer,
    createFirmwareGroup: CreateGroupFirmwareReducer,
    firmwareAssignGroup: FirmwareAssignGroupReducer,
    deleteGroup: DeleteGroupReducer,
    configurationAssignGroup: ConfigurationAssignGroupReducer,
    deviceHistory: DeviceHistoryReducer,
    SchdulerListData: getAllSchdulerListSliceReducer,
    createReportTemplateState: createReportTemplateReducer,
    templateDetailsListState: templateDetailsListReducer,
    reportContentColumns: reportContentColumnReducer,
    editReportTemplateState: editReportTemplateSlice,
    deleteReportTemplateState: deleteReportTemplateSlice,
    firmwareUnassignGroup: FirmwareUnassignGroupReducer,
    SchdulerDropDownListData: SchedulerDropDownReducer,
    CreateSchedulerTemplate: createSchedulerTemplateReducer,
    SchedulerFilterDropDownListData: getSchedulerfilterDropdownReducer,
    KpiUserPreference: getKpiPreferenceReducer,
    deleteScheduler: deleteSchedulerSlice,
    pauseScheduler: pauseSchedulerSlice,
    resumeScheduler: resumeSchedulerSlice,
    exportSchedulerDa: exportSchedulerDataReducer,
    SFTPConfigurationData: createSFTPConfigurationReducer,
    ConfigurationMetadata: createConfigurationMetadataReducer,
    ConfigurationListData: configurationListDetailsReducer,
    UpateProtocolConfigurationResponce: updateConfigurationProtocolReducer,
    firmwareCampaignDetails: firmwareCampaignDetailsReducer,
    FirmwareCreateCampaignState: firmwareCreateCampaignReducer,
    firmwareCampaignListState: firmwareCampaignListReducer,
    // History Table Generic
    KpiHistoryARState: HistoryARTableReducer,
    KpiHistoryADSState: HistoryADSTableReducer,
    KpiHistoryASState: HistoryASTableSlice,
    // Bar Kpis
    TotalConnectedState: totalConnectedSlice,
    TotalRegisteredState: totalRegisteredSlice,
    TotalShippedState: totalShippedSlice,
    TotalStaleState: totalStaleSlice,
    LastReadAlarmsData: lastReadAlarmsReducer,
    // donut kpi
    totalReadsDonutData: totalReadsDonutDataReducer,
    ecModeDonutData: ecModeDonutSlice,
    historyDonutState: historyDonutReducer,
    donutKpiHistoryTableState: historyDonutTableReducer,
    donutKpiBarGraphData: donutKpiBarGraphSlice,
    signalBreakdownData: signalBreakdownSlice,
    alarmBreakdownData: alarmBreakdownSlice,
    firmwareBreakdownData: firmwareBreakdownSlice,
    batteryBreakdownData: batteryBreakdownSlice,
    lifecycleBreakdownData: lifecycleBreakdownSlice,
    // Scheduler, firmware, group
    groupWithCountListState: groupWithCountListReducer,
    firmwareCampaignDeleteState: firmwareCampaignDeleteReducer,
    firmwareCampaignDetailsState: firmwareCampaignDetailsReducer,
    FirmwareUpgradeStatusList: exportFirmwareUpgradeStatusListReducer,
    FirmwareCampaignDetailsList: exportFirmwareCampaignListReducer,
    SchdulerHistoryListData: SchedulerHistoryListReducer,
    uploadAssetProfileInfoState: uploadAssetProfileInfoSlice,
    alarmHistoryState: alarmHistorySlice,
    // Seed
    seedState: seedReducer,
    FirmwareCampaignFilterMetaData: getFirmwareCampaignFilterMetaDataReducer,
    // ThermalIQ Custom KPI
    customKpi: customKpiSlice,
    tiqAssetList: assetListSlice,
    deviceParameters: deviceParameterSlice,
    createCustomKpi: createCustomKpiSlice,
    kpiDetails: customKpiDetails,
    tiqSiteList: siteList,
    editCustomKpi: editCustomKpiSlice,
    kpiConfigurations: kpiConfigurationSlice,
    // device management
    deviceManagementDeviceList: deviceManagementDeviceListSlice,
    deviceDeleteState: deviceDeleteReducer,
    deviceManagementGatewayInfo: gatewayInfoSlice,
    assetCategories: assetCategoriesSlice,
    deviceType: deviceTypeSlice,
    deviceModel: deviceModelSlice,
    performanceIndicator: indicatorSlice,
    deviceInfoState: deviceInfoSlice,
    modbusParameters: modbusParamsSlice,
    updateDeviceState: updateDeviceReducer,
    downloadImageState: downloadImageReducer,
    deviceIndicatorState: addDeviceIndicatorReducer,
    deviceParameterState: addDeviceParameterReducer,
    defaultParameterState: addDefaultParameterReducer,
    imageUploadState: imageUploadReducer,
    createDeviceState: createDeviceReducer,
    defaultIndicatorState: addDefaultIndicatorReducer,
    alarmMetaDataState: alarmMetaData,
    frequencyMetaDataState: frequencyMetaData,
    // gateway management
    gatewayManagementGatewayList: gatewayManagementGatewayListSlice,
    // asset management
    assetManagementAssetList: assetManagementAssetListSlice,
    assetManagementSiteInfo: siteInfoSlice,
    gatewayDeleteState: gatewayDeleteReducer,
    assetDeleteState: assetDeleteReducer,
    gatewayManagementAssetInfo: assetInfoSlice,
    updateAssetState: updateAssetSlice,
    gatewayManagementAssetCategories: assetCategoriesSliceGateway,
    gatewayManagementGatewayType: gatewayTypeSlice,
    createGatewayState: createGatewayReducer,
    imageUploadStateGateway: imageUploadReducerGateway,
    createAssetState: createAssetReducer,
    imageUploadStateAsset: imageUploadReducerAsset,
    gatewayInfoState: gatewayInfoSliceGateway,
    updateGatewayState: updateGatewayReducer,
    downloadImageStateGateway: downloadImageReducerGateway,
    // device Dashbaord
    flameSignalReadingData: FlameSignaGraphDataSliceReducer,
    flameSignalData_NEW: FlameSignaGraphDataSliceReducer_NEW,
    flameSignaGraphKPIData: getFlameSignaGraphKPIDataSlice,
    flowSignalParamData: flowSignalParamDataSlice,
    flowSignalKpiData: flowSignalKpiDataSlice,
    flowSignalReadingData: FlowSignaGraphDataSliceReducer,
    ModBusParameterListData: modbusParamsSliceReducer,
    DeviceListData: DeviceListReducer,
    StandardandCustomListData: StandardandCustomListDataReducer,
    DeviceStatusListData: DeviceStatusReducer,
    AlertsCountDetailsData: AlertCountDetailsReducer,
    SaveDefaultViewData: SaveDefaultViewDetailsReducer,
    SaveBookmarkData: SaveBookmarkDetailsReducer,
    GetBookmarkData: GetBookmarkDetailsReducer,
    AlertsNotificationData: AlertsNotificationReducer,
    ClearNotificationData: ClearNotificationReducer,
    AcknowledgeNotificationData: acknowledgeNotificationNotificationReducer,
    DeviceStatusOnlineData: DeviceOnlineStatusReducer,
    ExportGraphDataState: exportDeviceGrapData,
    ExportGraphKPIDataState: exportGraphKPIDataSlice,
    HealthSummaryState: healthSummarySlice,
    deviceStatusRegisterSummaryState: deviceStatusRegisterSummarySlice,
    deviceStatusKPISummaryState: deviceStatusKPISummarySlice,
    // site management
    siteManagementSiteList: siteManagementSiteListSlice,
    siteDeleteState: siteDeleteReducer,
    createSiteState: createSiteReducer,
    imageUploadStateSite: imageUploadReducerSite,
    siteInfoState: siteInfoReducer,
    downloadImageSiteState: downloadImageReducerSite,
    updateSiteState: updateSiteReducer,
    // custom device template
    customDeviceList: customDeviceListSlice,
    customDeviceDeleteState: customDeviceDeleteReducer,
    createCustomDeviceInfoState: customDeviceInfoReducer,
    exportCustomDeviceData: customDeviceDataExportReducer,
    deviceDropDownMetadata: customDeviceDropDownMetaReducer,
    UpdateCustomDevice: updateDeviceTemplateReducer,
    customDeviceListByID: getDeviceByIdReducer,
    menuInfoState: menuInfoReducer,
    saveDefaultWidgetData: saveDefaultViewWidgetDetailsReducer,
    saveDefaultViewObject: SaveDefaultViewObjectReducer,
    saveBookmarkObject: SaveBookmarkObjectReducer,
    timezoneDropDownMetaData: TimezoneDropDownReducer,
    assetHealthScore: healthScoreReducer,
    assetAlarmState: assetAlarmReducer,
    HealthScoreAssetDashboard: healthScoreAssetDashboardReducer,
    headerSummaryRegisterAssetData: assetHeaderRegisterSummaryReducer,
    headerSummaryKPIAssetData: assetHeaderKPISummaryReducer,
    assetKpiAlarmData: addAssetKpiAlarmReducer,
    assetPerformanceData: assetPerformanceDataReducer,
    AssetPerformanceKPIData: assetPerformanceKPIDataReducer,
    AlertCountDataAssetDashboard: assetAlertCountDataReducer,
    alertTrendRegisterAssetDashboard: alertTrendRegisterDataAssetDashboardReducer,
    alertTrendKPIAssetDashboard: alertTrendKPIDataAssetDashboardReducer,
    alertTrendRegisterDeviceDashboard: alertTrendRegisterDataDeviceDashboardReducer,
    alertTrendKPIDeviceDashboard: alertTrendKPIDataDeviceDashboardReducer,
    kpiAssetList: kpiAssetListReducer,
    parameterTree: parameterTreeReducer,
    FlameSignaGraphDataAssetDashboard: FlameSignaGraphDataAssetDashboardSliceReducer,
    FlowSignaGraphDataAssetDashboard: FlowSignaGraphDataAssetDashboardSliceReducer,
    flameKPIAssetData: flameKPIAssetDataReducer,
    flameRegisterData: flameRegisterDateReducer,
    flowKPIAssetData: flowKPIAssetDataReducer,
    flowRegisterData: flowRegisterDataReducer,
    getParameterConfigurationData: getParameterConfigurationDataReducer
  },
  middleware: [thunk, logger]
})

export default store
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
